import React, { useEffect, useState } from 'react';
import './LoadingScreen.css';

const LoadingScreen = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  if (!isLoading) return null;

  return (
    <div className="loading-screen">
      <div className="flipping-coin">
        <img 
          src="https://zupimages.net/up/25/05/kdn8.png" 
          alt="BUGATTEA Logo" 
          className="coin-logo" 
        />
      </div>
      <div className="loading-text"></div>
    </div>
  );
};

export default LoadingScreen;